import { axiosInstance } from "../axiosInstance";

export const getAllBodytype =async () => {
  const instance =await axiosInstance();
  return await instance.get("/bodytype/all");
};
